import { API_URL, ADMIN_EMAIL } from '../config/env';
import { createBearerJsonClient } from './apiFetchPolicy';

function notifyApi() {
  return createBearerJsonClient(null, { baseURL: API_URL });
}

/**
 * Send email notification when a new user registers
 * @param {Object} userData - User registration data
 * @param {string} userData.name - User's name
 * @param {string} userData.email - User's email
 * @returns {Promise<void>}
 */
export const sendNewUserNotification = async (userData) => {
    try {
        await notifyApi().post('/auth/notify-new-user', {
            userEmail: userData.email,
            userName: userData.name,
            ...(ADMIN_EMAIL && { notificationEmail: ADMIN_EMAIL }),
        });
    } catch (error) {
        // Log error but don't throw - email notification failure shouldn't block registration
        console.error('Failed to send new user notification email:', error);
    }
};

/**
 * Send payment confirmation emails to both user and admin
 * @param {Object} orderData - Order data
 * @param {string} orderData.orderId - Order ID
 * @param {string} orderData.userEmail - User's email address
 * @param {string} orderData.userName - User's name
 * @param {number} orderData.total - Order total amount
 * @param {Array} orderData.items - Order items
 * @param {string} orderData.shippingAddress - Shipping address
 * @returns {Promise<void>}
 */
export const sendPaymentNotification = async (orderData) => {
    try {
        await notifyApi().post('/auth/notify-payment', {
            orderId: orderData.orderId,
            userEmail: orderData.userEmail,
            userName: orderData.userName,
            total: orderData.total,
            items: orderData.items,
            shippingAddress: orderData.shippingAddress,
            ...(ADMIN_EMAIL && { adminEmail: ADMIN_EMAIL }),
        });
    } catch (error) {
        // Log error but don't throw - email notification failure shouldn't block payment
        console.error('Failed to send payment notification email:', error);
    }
};

